const statsComp = (gsap, ScrollTrigger) => {
 
	const $statTexts = $('.comp__stats-counter .stat-text');
	
	/***************************************************************
		CS STATS ANIMATION
	***************************************************************/
 
	if ($statTexts) {
		
		$statTexts.each(function() {
			
			const $this = $(this);
			const $text = $this.text();
			
			gsap.to($this, {
				scrambleText: {
					text: $text,
					chars: "#$@",
					revealDelay:1,
					tweenLength:false,
				}
			})
			
			gsap.to($this, {
				scrollTrigger: {
					trigger: ".comp__stats-counter",
					start: "top center",
				},
				scrambleText:{
					text: $text, 
					chars:"#$@", 
					speed:0.4
				},
				onStart: function() {
					$this.addClass('tweening');
				},
				onComplete: function() {
					$this.removeClass('tweening');
				}
			});
			
		});
		
	}
		
	//ScrollTrigger.kill();

}

export {
	statsComp
};
